// The pixels-and-paper constants the print surfaces share: how many CSS pixels
// a millimetre of paper is, the width/height pair every measurement here comes
// back as, and how much of its container the print frame may fill.
//
// What is NOT here any more is the sizing arithmetic this file was named for.
// The preview frame used to be a DOM rectangle sized to the paper's own
// proportions inside the container, and computing that was the file's whole
// job; the frame is map geometry now (`printFrame.ts` builds it in the
// national CRS, `PrintFrameLayers` draws it), so only these constants
// survived. They stayed rather than moving into `printFrame.ts` because
// `PAGE_PX_PER_MM` has a consumer outside the frame code — `mapBorders.ts`
// uses it in `groundEquivalentPrintZoom`, which turns a paper scale into the
// screen zoom that shows the same ground per pixel, so a printed border keeps
// the screen's width law — and that has nothing to do with the crop frame.

/** CSS pixels per millimetre at the 96dpi CSS reference resolution. */
export const PAGE_PX_PER_MM = 96 / 25.4

export interface Size {
  w: number
  h: number
}

/**
 * How much of the container the print frame may occupy, per axis, when the map
 * is fitted to it (see `zoomToFitFrame`). The remaining 12% is breathing room:
 * a frame whose edge sat exactly on the container's would read as a crop of the
 * map rather than as a rectangle drawn on it.
 */
export const FRAME_INSET = 0.88
